import React, { useState, useEffect, useCallback } from "react";
import { Table, Image, Form, Col, Modal, Row } from "react-bootstrap";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { NavLink, useHistory } from "react-router-dom";

import "react-circular-progressbar/dist/styles.css";
import { Menu, MenuItem } from "@material-ui/core";
import UserModal from "./UserModal";
import EditUser from "./EditUser";
import BasicPagination from "./../../../Pagination/Pagination";

import { getAllUsersList, getAllUsersStats } from "../../../../store/actions/SuperAdminActions/adminCategoryAndIconsAction";
import PropTypes from "prop-types";
import { connect, useDispatch } from "react-redux";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import moment from "moment";
import { SuperAdminTopTextSearchIcon } from "../../superAdminReusable/reusableTable/SuperAdminTopTextSearchIcon";
import { RightSideCountTop } from "../superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";
import SelectFilter from "../../../reusableComponents/selectFilter";
import { FormControl, Select, InputLabel, TextField } from "@material-ui/core";
import isEmpty from "../../../../store/validation/is-Empty";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { SortComponent } from "../../../reusableComponents/SortAndFilterComponent/SortComponent";
import CSVDownloader from "../../../reusableComponents/csvDownload/csvDownload";
import NoContent from "../../../reusableComponents/NoContentComponent";
import Debounce from "../../../../function/debounce";
import { amApi } from "../../../../api/apiHelper";
import { errorAlert } from "../../../../function/alert";
import { SUPERADMIN_ALL_USER_LIST, SUPERADMIN_ALL_USER_RANGE } from "../../../../store/types";


const profileCompletion = [
  { id: 1, title: "1-25%" },
  { id: 2, title: "26-50%" },
  { id: 3, title: "51-75%" },
  { id: 4, title: "76-100%" },
];

const MainSuperAdminUsers = (props) => {
  //state
  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  //const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const [showFilter, setShowFilter] = useState(false);
  const [currentUserData, setCurrentUserData] = useState([]);
  const [profile, setProfile] = useState();
  const [startProfilePer, setStartProfilePer] = useState("");
  const [endProfilePer, setEndProfilePer] = useState("");
  const handleCloseEdit = () => setShowEdit(false);
  const [dateQuery, setDateQuery] = useState({});
  const [range, setRange] = useState('');
  const handleShowEdit = (user) => {
    setCurrentUserData(user);
    setShowEdit(true);
  };

  const [page, setPage] = useState(1);
  // var page = 1;

  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    // var calcStart = pageNo * 10 - 10;
    // setStart(calcStart);
    // setEnd(pageNo * 10);
    let query = {}
    if (search) {
      query.search = search;
    }
    props.getAllUsersList(
      search,
      searchByUserId,
      phoneNumberSearch,
      { ...dateQuery, page: pageNo, ...query },
      props.auth.user.accessToken,
      onSuccessLoadUsers
    );
    setPage(pageNo);
    //page = pageNo;
  };

  const onSuccessLoadUsers = () => {
    setLoading(false);
  };
  const [search, setSearch] = useState("");
  const [isActive, setActive] = useState(false);
  const [stats, setStats] = useState({ total: 0, active: 0, inactive: 0 });
  const [searchByUserId, setSearchByUserId] = useState("");
  const [phoneNumberSearch, setPhoneNumberSearch] = useState("");
  const [locationSearch, setLocationSearch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startDateSearch, setStartDateSearch] = useState("");
  const [endDateSearch, setEndDateSearch] = useState("");
  const [userData, setUserData] = useState([]);

  const userFilter = [
    { title: "User Name", disabled: true },
    { title: "A-Z", disabled: false },
    { title: "Z-A", disabled: false },
    { title: "User Activity", disabled: true },
    { title: `Date & Time 🠑`, disabled: false },
    { title: "Date & Time 🠓", disabled: false },
  ];

  const onDateChangeHandler = () => (data, type, selected) => {
    dispatch({
      type: SUPERADMIN_ALL_USER_RANGE,
      payload: selected,
    })
    setDateQuery(data);
  };

  useEffect(() => {
    if (!isEmpty(dateQuery)) {
      let query = {}
      if (search) {
        query.search = search;
      }
      props.getAllUsersList(
        search,
        searchByUserId,
        phoneNumberSearch,
        { ...dateQuery, ...query },
        props.auth.user.accessToken,
        onSuccessLoadUsers
      );
      props.getAllUsersStats({ ...dateQuery, ...query });
    }
  }, [dateQuery, search, props.selectedRange]);

  const [filter, setFilter] = useState({
    location: "",
    percentage: "",
    search: false,
  });

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [userSort, setUserSort] = useState("");

  useEffect(() => {
    setUserData(props.allUserList);
  }, [props.allUserList]);

  /*********************************
   * @DESC SORT FILTER ACTION
   *********************************/
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };


  const onChange = async (value) => {
    try {
      if (value) {
        let data = await amApi.get(`/admin/user-service?search=${value}`);
        data = data.data;
        dispatch({
          type: SUPERADMIN_ALL_USER_LIST,
          payload: data,
        });
      }
    } catch (err) {
      errorAlert('Something went wrong, try again later')
    }
  }

  const debounceOnChange = useCallback(Debounce(onChange, 1000), []);


  const downloadData = {
    headers: [
      { label: "User Name", key: "userName" },
      { label: "User Id", key: "userId" },
      { label: "Location", key: "location" },
      { label: "Seatings", key: "seatings" },
      { label: "Orders", key: "orders" },
      { label: "Favourites", key: "favs" },
      { label: "Scan", key: "scan" },
      { label: "Events", key: "events" },
      { label: "Reviews", key: "reviews" },
      { label: "Profile Completion", key: "profile" },
      { label: "Last Activity", key: "lastActivity" },
      { label: "Member Since", key: "member" },
      { label: "Email", key: "email" },
      { label: "Mobile", key: "mobile" },
      { label: "status", key: "status" },
    ],
    data: userData.map((ele) => {
      return {
        userName: `${ele?.first_name || ""} ${ele?.last_name || ""}`,
        userId: ele._id,
        location: ele.city || "",
        seatings: ele.totaldiner,
        orders: ele.totalOrderings,
        favs: ele.totalFavs,
        scan: ele?.totalScans,
        events: ele.totalEvents,
        reviews: ele?.totalReviewRating,
        profile: ele?.profile_percentage,
        lastActivity: `${moment(ele?.updatedAt).format("ll")}`,
        member: `${moment(ele?.createdAt).format("ll")}`,
        email: ele?.email,
        mobile: `${ele?.country_code} ${ele?.mobile_number}`,
        status: `${ele?.user_verified ? "verified" : "unverified"}`,
      };
    }),
  };

  let filteredData = userData.sort(function (a, b) {
    let nameA = a && a.first_name && a.first_name.toLowerCase(); // ignore upper and lowercase
    let nameB = b && b.first_name && b.first_name.toLowerCase(); // ignore upper and lowercase
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  });

  if (userSort === "A-Z") {
    filteredData = filteredData.sort((a, b) => {
      if (
        a?.first_name?.toLowerCase() + " " + a?.last_name?.toLowerCase() <
        b?.first_name?.toLowerCase() + " " + b?.last_name?.toLowerCase()
      )
        return -1;
      if (
        a?.first_name?.toLowerCase() + " " + a?.last_name?.toLowerCase() >
        b?.first_name?.toLowerCase() + " " + b?.last_name?.toLowerCase()
      )
        return 1;
      return 0;
    });
  } else if (userSort === "Z-A") {
    filteredData = filteredData.sort((a, b) => {
      if (
        a?.first_name?.toLowerCase() + " " + a?.last_name?.toLowerCase() <
        b?.first_name?.toLowerCase() + " " + b?.last_name?.toLowerCase()
      )
        return 1;
      if (
        a?.first_name?.toLowerCase() + " " + a?.last_name?.toLowerCase() >
        b?.first_name?.toLowerCase() + " " + b?.last_name?.toLowerCase()
      )
        return -1;
      return 0;
    });
  } else if (userSort === "Date & Time 🠑") {
    filteredData = filteredData.sort(
      (a, b) => new Date(a.updatedAt) - new Date(b.updatedAt)
    );
  } else if (userSort === "Date & Time 🠓") {
    filteredData = filteredData.sort(
      (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
    );
  }


  if (filter.percentage === 1)
    filteredData = filteredData.filter((item) => {
      return item.profile_percentage >= 0 && item.profile_percentage <= 25;
    });
  else if (filter.percentage === 2)
    filteredData = filteredData.filter((item) => {
      return item.profile_percentage >= 26 && item.profile_percentage <= 50;
    });
  else if (filter.percentage === 3)
    filteredData = filteredData.filter((item) => {
      return item.profile_percentage >= 51 && item.profile_percentage <= 75;
    });
  else if (filter.percentage === 4)
    filteredData = filteredData.filter((item) => {
      return item.profile_percentage >= 76 && item.profile_percentage <= 100;
    });
  if (filter.location)
    filteredData = filteredData.filter((item) => {
      return item?.city
        ?.toLowerCase()
        .includes(filter.location.toLowerCase());
    });

  return (
    <>
      {loading ? (
        <AmealioLoader />
      ) : (
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation displayText="All Users" />
              <Col>
                <Col className="d-flex justify-content-between align-items-center pt-4 pb-3">
                  <div className="f24_700_HelveticaNeue">
                    User Management
                    <p className="f12-400 opacity5" style={{ fontWeight: 400 }}>
                      Manage all the users onboarded in Amealio and track their
                      each and every activities
                    </p>
                  </div>
                  <NavLink
                    to="/adduser"
                    className="btn addBtnRed btn2 btn-lg"
                    style={{ borderRadius: "30px" }}
                  >
                    Add User
                  </NavLink>
                </Col>
              </Col>

              <div className="super-admin-inside-right-side-panel">
                <Row className=" mb-3 flexcenter">
                  <Col md={6}>
                    <div className="d-flex  align-items-center justify-content-start">
                      <div className={`newexpandablesearch ${isActive ? "active" : null}`}>
                        <div className="searchicon">
                          <i onClick={() => { setActive(!isActive); setSearch(''); }} className="fa fa-search" aria-hidden="true" style={{ fontSize: "20px" }}></i>
                        </div>
                        <div className="input">
                          <Form.Control
                            type="text"
                            placeholder="Search - Name, Location, UserID, Phone No."
                            className="newsearchinput"
                            value={search}
                            onChange={(e) => { setSearch(e.target.value); debounceOnChange(e.target.value) }}
                            style={{ borderRadius: "28px" }}
                          />
                          <i className="fa fa-timesw" aria-hidden="true"></i>
                        </div>
                      </div>

                      <div
                        className="f10-400"
                        align="center"
                        onClick={() => setShowFilter(!showFilter)}
                      >
                        <img
                          src={require("../../../../assets/images/iconButton/filterbtn.svg")}
                          width="80px"
                          alt="icon"
                        />
                      </div>
                      <div>
                        <div
                          className="f10-400"
                          align="center"
                          aria-controls="simple-menu"
                          aria-haspopup="true"
                          onClick={handleClick}
                        >
                          <img
                            src={require("../../../../assets/images/iconButton/sortbtn.svg")}
                            width="80px"
                          />
                        </div>
                        <Menu
                          id="simple-menu"
                          anchorEl={anchorEl}
                          keepMounted
                          open={Boolean(anchorEl)}
                          onClose={handleClose}
                        >
                          {userFilter.map((ele, index) => {
                            return (
                              <MenuItem
                                value={ele.title}
                                key={index}
                                onClick={() => setUserSort(ele.title)}
                                disabled={ele.disabled}
                                style={{ fontWeight: "700" }}
                              >
                                {ele.title}
                              </MenuItem>
                            );
                          })}
                        </Menu>
                      </div>
                      <CSVDownloader
                        filename={"users"}
                        headers={downloadData.headers}
                        data={downloadData.data}
                      />
                    </div>
                  </Col>
                  <div className="col-1"></div>
                  <div className="col-3">
                    <div className="mr-3"></div>
                  </div>
                  <div className="col-2"></div>
                </Row>
                {showFilter && (
                  <div
                    className="container-fluid p-4"
                    style={{
                      backgroundColor: "#ffffff",
                      transition: "height 2s",
                    }}
                  >
                    <Row>
                      <Col md={6}>
                        <Form.Group>
                          <FormControl variant="outlined" className="w-100">
                            <InputLabel htmlFor="outlined-Status">
                              Profile Completion
                            </InputLabel>
                            <Select
                              value={filter.percentage}
                              onChange={(e) =>
                                setFilter({
                                  ...filter,
                                  percentage: e.target.value,
                                })
                              }
                              label="Profile Completion"
                              inputProps={{
                                name: "Profile Completion",
                                id: "outlined-Status",
                              }}
                              IconComponent={KeyboardArrowDownIcon}
                            >
                              {profileCompletion.map((item, index) => (
                                <MenuItem
                                  label={item.title}
                                  value={item.id}
                                  key={item.id + index}
                                >
                                  {item.title}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group>
                          <FormControl variant="outlined" className="w-100">
                            <TextField
                              id="outlined-flexible"
                              label="Location"
                              value={filter.location}
                              onChange={(e) =>
                                setFilter({
                                  ...filter,
                                  location: e.target.value,
                                })
                              }
                              variant="outlined"
                            />
                          </FormControl>
                        </Form.Group>
                      </Col>
                    </Row>
                    <div className="mt-5 d-flex">
                      <button
                        type="button"
                        className="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                        title="Cancel Button"
                        onClick={() => {
                          setFilter({
                            category: "",
                            status: "",
                            type: "",
                            search: false,
                          });
                          setShowFilter(!showFilter);
                        }}
                      >
                        Reset
                      </button>
                      <button
                        type="button"
                        className="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                        title="Confirm Button"
                        onClick={() => {
                          setFilter({ ...filter, search: true });
                          setShowFilter(!showFilter);
                        }}
                      >
                        Apply Filter
                      </button>
                    </div>
                  </div>
                )}
                <hr />
                <div className="d-flex justify-content-space-between mt-3 mb-3">
                  <SelectFilter
                    defaultSelected={props?.history?.location?.state?.back ? props.selectedRange : "TODAY"}
                    onDateChange={onDateChangeHandler()}
                  />
                  <RightSideCountTop
                    content={[
                      {
                        name: "Total Users",
                        value: `${props.stats.totalUsers}`,
                        backgroundColor: "#FFEDE9",
                        color: "#EE3A23",
                      },
                      {
                        name: "Active Users",
                        value: `${props.stats.activeUsers}`,
                        backgroundColor: "#EFEBFB",
                        color: "#6F32C9",
                      },
                      {
                        name: "Inactive Users",
                        value: `${props.stats.inactiveUsers}`,
                        backgroundColor: "#D8F3F4",
                        color: "#008B90",
                      },
                    ]}
                  />
                </div>
                <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
                  <Table>
                    <thead>
                      <tr className="super_admin_all_users_table_head">
                        <th style={{ width: "20%" }} className="f12-700">
                          User Name/
                          <br /> User ID
                        </th>
                        <th style={{ width: "15%" }} className="f12-700">
                          Location
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Seating <br /> / Orders
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Events <br /> / Scan
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Favourites <br />/ Reviews
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Mode Of <br />
                          Referral
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Profile <br />
                          Completion %
                        </th>
                        <th style={{ width: "15%" }} className="f12-700">
                          Last Activity <br />
                          Date
                        </th>
                      </tr>
                    </thead>
                    {/* {console.log(filterByAndSearch)} */}
                    {filteredData?.length ? (filteredData.map((user, index) => (
                      <UserModal
                        user={user}
                        key={index}
                        handleShowEdit={(cUser) => handleShowEdit(cUser)}
                      />
                    ))) : <NoContent />}
                  </Table>
                </div>
                {props.stats?.totalUsers > 0 ? (
                  <BasicPagination
                    totalRecords={props.stats?.totalUsers}
                    limit={10}
                    batch={page}
                    onBatchChange={(e) => handleBatchChange(e)}
                  />
                ) : (
                  <> </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <Modal show={showEdit} onHide={handleCloseEdit} centered size="lg">
        <Modal.Header className="border-0 pl-4" closeButton>
          <Modal.Title className="f24-700">Edit User Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4 f16-500">
          <div className="d-flex">
            <div className="user-profile-image m-0">
              <Image
                src={require("../../../../assets/images/ActionImages/demoprofile.jpg")}
              />
            </div>
            <div className="pl-3 pt-2">
              <div className="f21-700 pb-2">{currentUserData.first_name}</div>
              {currentUserData.age ? (
                <div className="f13-500 greenLbl text-white">
                  {" "}
                  {currentUserData.age}
                </div>
              ) : (
                <> </>
              )}
            </div>
          </div>
          <EditUser data={currentUserData} CloseEdit={handleCloseEdit} />
        </Modal.Body>
      </Modal>
    </>
  );
};
MainSuperAdminUsers.propTypes = {
  auth: PropTypes.object.isRequired,
  getAllUsersList: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  allUserList: state.userManagement.allUserList,
  selectedRange: state.userManagement.allUserRange,
  stats: state.userManagement.allUserStats
});

export default connect(mapStateToProps, {
  getAllUsersList, getAllUsersStats
})(MainSuperAdminUsers);
